import { render } from "./StaffDetails.vue?vue&type=template&id=72139d00&scoped=true"
import script from "./StaffDetails.vue?vue&type=script&lang=js"
export * from "./StaffDetails.vue?vue&type=script&lang=js"

import "./StaffDetails.vue?vue&type=style&index=0&id=72139d00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72139d00"]])

export default __exports__